<div class="wrapper">
  <div class="content" *ngIf="init | async">
    <router-outlet></router-outlet>
  </div>
  <!-- Will be moved to cmx-client-layout later -->
  <app-action-bar></app-action-bar>
</div>
